import { Container, Paper, Stack, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import PaiMenuItem from 'features/ui/base-components/pai-menu-item';
import PaiSelect from 'features/ui/base-components/pai-select';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { Perspectives } from './lead-questionnaire.types';

interface Props {
  perspective: Perspectives;

  handleAnonymousPerspectiveChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleShowGreetingClick(): void;
}

const QuestionnairePerspective: React.FC<Props> = ({ perspective, handleAnonymousPerspectiveChange, handleShowGreetingClick }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const leadLogo = '/dashboard/images/lead/lead_logo.png';
  const options = [
    { label: t(Perspectives.BOSS), value: Perspectives.BOSS },
    { label: t(Perspectives.COLLEAGUE), value: Perspectives.COLLEAGUE },
    { label: t(Perspectives.EMPLOYEE), value: Perspectives.EMPLOYEE },
    { label: t(Perspectives.OTHER), value: Perspectives.OTHER },
  ];

  return (
    <Container maxWidth={'lg'}>
      <Stack gap={4}>
        <Typography className={classes.title}>
          <Trans i18nKey={'leadQuestionnaireGreeting'}>
            Herzlich Willkommen zum <b>LEaD-Führungsfeedback</b>
          </Trans>
        </Typography>
        <Stack direction={'row'} justifyContent={'center'}>
          <img className={classes.logo} src={leadLogo} alt="Lead Logo" />
        </Stack>
        <Stack gap={2}>
          <Paper className={classes.textContainer} elevation={2} square={true}>
            <Stack gap={2}>
              <Typography className={classes.text}>{t('leadQuestionnairePerspectiveText1')}</Typography>
              <Typography className={classes.text}>
                <Trans i18nKey={'leadQuestionnaireGreetingSelfPerspectiveText2'}>
                  herzlich Willkommen zum Führungsfeedback <b>„LEaD - Leadership Effectiveness and Development“</b>. Wir freuen uns, dass Sie an der
                  Befragung teilnehmen.
                </Trans>
              </Typography>
              <Typography className={classes.text}>{t('leadQuestionnairePerspectiveText3')}</Typography>
              <PaiSelect
                value={perspective}
                disableBorder={true}
                backgroundColor={'#FFF'}
                onChange={handleAnonymousPerspectiveChange}
                style={{ width: '250px' }}
              >
                {options.map((option) => (
                  <PaiMenuItem key={option.value} value={option.value}>
                    {option.label}
                  </PaiMenuItem>
                ))}
              </PaiSelect>
            </Stack>
          </Paper>
          <Stack direction={'row'} justifyContent={'flex-end'}>
            <PaiButton text={t('continue')} disabled={perspective.trim() === ''} size={'large'} action={handleShowGreetingClick} />
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
};

const useStyles = makeStyles()((theme) => ({
  title: {
    fontSize: theme.typography.pxToRem(32),
    textAlign: 'center',
  },
  logo: {
    width: '500px',
    height: 'auto',
    marginBottom: '16px',
  },
  textContainer: {
    padding: '24px 32px',
    background: 'rgba(0,0,0,0.03)',
  },
  text: {
    fontSize: theme.typography.pxToRem(18),
  },
}));

export default QuestionnairePerspective;
